/**
 * Which dashboard graphs to show, and how much room the Media Metrics card takes, from what each graph has
 * reported about its data ('loading', 'data' or 'empty', keyed by variant).
 *
 * - A bottom-row graph with nothing to draw is left out; the row goes with the last of them.
 * - With the graph beside the counters empty, Media Metrics takes the whole width of the top row.
 *
 * With every graph empty it used to take the bottom row's height as well. Switched off on review
 * (2 Nov 2026): stretched that tall, the tiles spread out and the card read as mostly gaps, so it only widens.
 *
 * Only a settled 'empty' hides anything. A graph still loading, or one that never reports (the file-level
 * tree maps), counts as having data, so nothing moves while the answers are on their way.
 *
 * @param {Object<string, string>} graphStates - What each graph last reported, by variant.
 * @param {string} leadVariant - The graph beside the Media Metrics card.
 * @param {string[]} trailingVariants - The graphs on the row below, in order.
 */
export const dashboardLayout = (graphStates, leadVariant, trailingVariants) => {
    const isEmpty = variant => graphStates[variant] === 'empty';
    const leadGraphHidden = isEmpty(leadVariant);
    const trailingGraphsHidden = trailingVariants.map(isEmpty);
    const bottomRowHidden = trailingGraphsHidden.every(Boolean);
    return {
        leadGraphHidden,
        trailingGraphsHidden,
        bottomRowHidden,
        mediaMetricsFullWidth: leadGraphHidden,
        // mediaMetricsFullHeight: leadGraphHidden && bottomRowHidden,
    };
};
